import { Avatar, Form, Select, Space } from "antd";
import React, { useMemo } from "react";
import type { FilterFunc } from "rc-select/lib/Select";
import type { DefaultOptionType } from "antd/es/cascader";
import type { UserLimitedList } from "../../generated-axios-client";
import type { IntlShape } from "@formatjs/intl";
import { avatarColor } from "../../../common/functions";

const assigneeSelectOptions = (userItems: UserLimitedList[]) =>
  userItems.map((item) => ({
    key: item.id,
    value: item.id,
    label:
      item.first_name && item.last_name
        ? `${item.first_name} ${item.last_name}`
        : item.username,
  }));

const searchHandler: FilterFunc<DefaultOptionType> = (input, option) =>
  (option?.label?.toString().toLowerCase() ?? "").includes(input.toLowerCase());

type Props = {
  intl: IntlShape;
  userItems: UserLimitedList[];
};

export const MultiAssigneeSelectorFormItem = ({ intl, userItems }: Props) => {
  const options = useMemo(() => assigneeSelectOptions(userItems), [userItems]);

  return (
    <Form.Item
      name="assignees"
      label={intl.formatMessage({ id: "filter_label_assignee" })}
    >
      <Select
        mode="multiple"
        showSearch={true}
        options={options}
        filterOption={searchHandler}
        allowClear
        optionRender={(option) => (
          <Space align="center" size="small">
            <Avatar
              size="small"
              style={{
                backgroundColor: avatarColor(option.label?.toString() ?? ""),
                flexShrink: 0,
              }}
            >
              {(option.label?.toString().split(" ") ?? [])[0]?.charAt(0).toUpperCase() ?? "?"}
            </Avatar>
            {option.label}
          </Space>
        )}
      />
    </Form.Item>
  );
};
